import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3ea61362"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cinema_folder_shortcut"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, " 常用文件夹 ", -1));
const _hoisted_3 = {
  key: 0,
  class: "move left"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "folder-card"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["title"];
const _hoisted_8 = {
  key: 1,
  role: "button",
  class: "move right"
};
import { useDeviceStore } from '@remote/store/device';
import Folder from '@shared/assets/img/cinema-empty.png';
import { openDialogCommon, openPopMenu } from '@remote/utils/dialog';
import { getFolderNameFromPath } from '@shared/utils/file';
import { onMounted, ref, watch } from 'vue';
import router from '@remote/router';
import { useScrollCollection } from '@shared/composable/cinema';
import { IconPageLeft } from '@xunlei/thunder-icon-vue';
import { newToast } from '@remote/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'CinemaFolderShortcut',
  setup(__props) {
    const deviceStore = useDeviceStore();
    const containerNodeRef = ref(null);
    const containerInnerNodeRef = ref(null);
    const {
      isScrollLeftShow,
      isScrollRightShow,
      scrollLeft,
      scrollRight,
      observe,
      unobserve
    } = useScrollCollection(containerNodeRef, containerInnerNodeRef);
    const getFolderName = (path = '') => {
      var _deviceStore$currentD, _deviceStore$currentD2;
      const pathSeparator = (_deviceStore$currentD = (_deviceStore$currentD2 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD2 === void 0 ? void 0 : _deviceStore$currentD2.deviceInfoRef.path_separator) !== null && _deviceStore$currentD !== void 0 ? _deviceStore$currentD : '/';
      return getFolderNameFromPath(path, pathSeparator);
    };
    const checkFileStillExist = async folder => {
      try {
        var _deviceStore$currentD3;
        await ((_deviceStore$currentD3 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD3 === void 0 ? void 0 : _deviceStore$currentD3.deviceFetch(`drive/v1/files/${folder.file_id}`, {}));
        return true;
      } catch (error) {
        if (error.error === 'file_not_found') {
          var _deviceStore$currentD4;
          newToast({
            type: 'error',
            message: '原路径已失效，将移除该文件夹'
          });
          (_deviceStore$currentD4 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD4 === void 0 ? void 0 : _deviceStore$currentD4.indexShortCut.remove(folder.id, {
            silence: true
          });
          return false;
        }
        return true;
      }
    };
    const onShortcutClicked = async folder => {
      if (!folder.file_id) return;
      const result = await checkFileStillExist(folder);
      if (result) {
        var _getFolderName, _folder$config$mount_, _folder$config;
        router.push({
          path: '/local-files',
          query: {
            ...router.currentRoute.value.query,
            origin: JSON.stringify({
              title: (_getFolderName = getFolderName((_folder$config$mount_ = (_folder$config = folder.config) === null || _folder$config === void 0 ? void 0 : _folder$config.mount_path) !== null && _folder$config$mount_ !== void 0 ? _folder$config$mount_ : '')) !== null && _getFolderName !== void 0 ? _getFolderName : '',
              parent_id: folder.file_id,
              action_from: 'main_page_file',
              filter: JSON.stringify({
                trashed: {
                  eq: false
                },
                phase: {
                  eq: 'PHASE_TYPE_COMPLETE'
                },
                mime_type: {
                  prefix: ['folder', 'video/']
                }
              })
            })
          }
        });
      }
    };
    const onLongPressed = async fs => {
      var _getFolderName2, _fs$config;
      console.log('onLongPressed');
      const res = await openPopMenu({
        title: (_getFolderName2 = getFolderName((_fs$config = fs.config) === null || _fs$config === void 0 ? void 0 : _fs$config.mount_path)) !== null && _getFolderName2 !== void 0 ? _getFolderName2 : '',
        options: ['打开文件夹', '删除', '取消'],
        danger: [1]
      });
      if (res === '打开文件夹') {
        onShortcutClicked(fs);
      }
      if (res === '删除') {
        const res = await openDialogCommon({
          title: '温馨提示',
          body: '确定删除所选文件夹么？',
          checker: '同时删除本地文件',
          checkerDefaultState: false,
          buttonDirection: 'horizontal',
          center: true,
          button: [{
            text: '确定',
            value: 'confirm',
            danger: true
          }, {
            text: '取消',
            value: 'cancel'
          }]
        });
        if (res.result === 'confirm') {
          var _deviceStore$currentD5;
          (_deviceStore$currentD5 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD5 === void 0 ? void 0 : _deviceStore$currentD5.indexShortCut.remove(fs.id);
          newToast({
            type: 'success',
            message: '删除成功'
          });
          if (res.isChecked) {
            var _deviceStore$currentD6;
            await ((_deviceStore$currentD6 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD6 === void 0 ? void 0 : _deviceStore$currentD6.deviceFetch(`drive/v1/files/${fs.file_id}`, {
              method: 'DELETE'
            }));
          }
        }
      }
    };
    watch(containerInnerNodeRef, res => {
      if (res) {
        observe();
      } else {
        unobserve();
      }
    });
    onMounted(async () => {
      var _deviceStore$currentD7;
      await deviceStore.untilDeviceReady();
      (_deviceStore$currentD7 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD7 === void 0 ? void 0 : _deviceStore$currentD7.indexShortCut.initList();
    });
    return (_ctx, _cache) => {
      var _unref$currentDeviceR;
      const _directive_longpress = _resolveDirective("longpress");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("ul", {
        class: "folder_list hide-scrollbar disable-overscroll",
        ref_key: "containerNodeRef",
        ref: containerNodeRef
      }, [_unref(isScrollLeftShow) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", {
        role: "button",
        class: "click-area",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _unref(scrollLeft) && _unref(scrollLeft)(...args))
      }, [_createVNode(_unref(IconPageLeft), {
        width: "24",
        height: "24"
      })])])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "container__inner",
        ref_key: "containerInnerNodeRef",
        ref: containerInnerNodeRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref$currentDeviceR = _unref(deviceStore).currentDeviceRef) === null || _unref$currentDeviceR === void 0 ? void 0 : _unref$currentDeviceR.indexShortCut.folderList, folder => {
        var _folder$config2;
        return _withDirectives((_openBlock(), _createElementBlock("li", {
          class: "folder",
          key: folder.id,
          onClick: $event => onShortcutClicked(folder)
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: _unref(Folder),
          draggable: "false",
          class: "folder-img"
        }, null, 8, _hoisted_6)]), _createElementVNode("span", {
          class: "folder-name single-line-text",
          title: folder.config.mount_path
        }, _toDisplayString(getFolderName((_folder$config2 = folder.config) === null || _folder$config2 === void 0 ? void 0 : _folder$config2.mount_path)), 9, _hoisted_7)], 8, _hoisted_4)), [[_directive_longpress, () => onLongPressed(folder)]]);
      }), 128))], 512), _unref(isScrollRightShow) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", {
        class: "click-area",
        role: "button",
        onClick: _cache[1] || (_cache[1] =
        //@ts-ignore
        (...args) => _unref(scrollRight) && _unref(scrollRight)(...args))
      }, [_createVNode(_unref(IconPageLeft), {
        width: "24",
        height: "24"
      })])])) : _createCommentVNode("", true)], 512)]);
    };
  }
});